import { render, staticRenderFns } from "./BaoCan.vue?vue&type=template&id=7e72713a&scoped=true"
import script from "./BaoCan.vue?vue&type=script&lang=js"
export * from "./BaoCan.vue?vue&type=script&lang=js"
import style0 from "./BaoCan.vue?vue&type=style&index=0&id=7e72713a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e72713a",
  null
  
)

export default component.exports